import styled from "styled-components";

export const PageShell = styled.div`
  width: 100%;
  max-width: ${({ $wide }) => ($wide ? "none" : "1120px")};
  margin: 0 auto;
  padding: ${({ $roomy }) => ($roomy ? "2.75rem" : "1.25rem")}
    ${({ $wide }) =>
      $wide ? "clamp(1.25rem, 2.2vw, 2.25rem)" : "clamp(1rem, 3vw, 1.75rem)"}
    2.75rem;
  box-sizing: border-box;
  /* Scroll fica no SideContainer (lateral), não neste bloco */
`;

export const Intro = styled.p`
  margin: 0 0 1rem;
  color: var(--text-muted, var(--text-secondary));
  font-size: 0.95rem;
  line-height: 1.5;
  max-width: 70ch;
`;

export const ResultCount = styled.p`
  margin: 0 0 0.85rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-secondary);
`;

export const FilterChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin: 0 0 1rem;
`;

export const FilterChip = styled.button`
  appearance: none;
  border: 1px solid
    ${({ $active }) =>
      $active ? "var(--accent)" : "var(--border-default)"};
  background: ${({ $active }) =>
    $active
      ? "color-mix(in srgb, var(--accent) 16%, transparent)"
      : "var(--surface-overlay, var(--surface-1))"};
  color: ${({ $active }) =>
    $active ? "var(--accent-secondary, var(--accent))" : "var(--text-secondary)"};
  border-radius: 999px;
  padding: 0.4rem 0.85rem;
  font-size: 0.82rem;
  font-weight: ${({ $active }) => ($active ? 650 : 500)};
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover {
    border-color: var(--accent);
    color: var(--text-heading);
  }
`;

export const StatsRow = styled.div`
  display: none;
`;

export const StatCard = styled.div`
  display: none;
`;

export const CardsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
`;

export const AlertCard = styled.article`
  display: grid;
  grid-template-columns: 6px 1fr auto;
  gap: 0;
  align-items: stretch;
  border-radius: 16px;
  border: 1px solid var(--border-default);
  background: var(--surface-overlay, var(--surface-1));
  box-shadow: 0 8px 24px color-mix(in srgb, var(--text-primary) 5%, transparent);
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: color-mix(in srgb, var(--accent) 45%, var(--border-default));
    transform: translateY(-1px);
    box-shadow: 0 12px 28px color-mix(in srgb, var(--text-primary) 8%, transparent);
  }

  &:focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 2px;
  }

  @media (max-width: 720px) {
    grid-template-columns: 6px 1fr;
  }
`;

export const SeverityRail = styled.div`
  background: ${({ $tone }) =>
    $tone === "high"
      ? "var(--danger)"
      : $tone === "medium"
        ? "var(--warning, #d97706)"
        : "var(--accent)"};
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  padding: 1rem 1.15rem;
  min-width: 0;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
`;

export const TypeIconWrap = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  color: ${({ $tone }) =>
    $tone === "high"
      ? "var(--danger)"
      : $tone === "medium"
        ? "var(--warning, #d97706)"
        : "var(--accent)"};
  background: ${({ $tone }) =>
    $tone === "high"
      ? "color-mix(in srgb, var(--danger) 14%, transparent)"
      : $tone === "medium"
        ? "color-mix(in srgb, var(--warning, #d97706) 16%, transparent)"
        : "color-mix(in srgb, var(--accent) 16%, transparent)"};
`;

export const CardTitleBlock = styled.div`
  min-width: 0;
  flex: 1;
`;

export const CardTitle = styled.h2`
  margin: 0;
  font-size: 1.05rem;
  color: var(--text-heading);
  line-height: 1.3;
`;

export const CardSubtitle = styled.p`
  margin: 0.15rem 0 0;
  color: var(--text-secondary);
  font-size: 0.86rem;
  line-height: 1.35;
`;

export const MetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  color: ${({ $tone }) =>
    $tone === "high"
      ? "var(--danger)"
      : $tone === "medium"
        ? "var(--warning, #d97706)"
        : "var(--accent)"};
  background: ${({ $tone }) =>
    $tone === "high"
      ? "color-mix(in srgb, var(--danger) 14%, transparent)"
      : $tone === "medium"
        ? "color-mix(in srgb, var(--warning, #d97706) 16%, transparent)"
        : "color-mix(in srgb, var(--accent) 16%, transparent)"};
`;

export const NeutralBadge = styled(Badge)`
  color: var(--text-secondary);
  background: color-mix(in srgb, var(--text-secondary) 12%, transparent);
`;

export const CardText = styled.p`
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.88rem;
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CardMetaLine = styled.p`
  margin: 0;
  color: var(--text-muted, var(--text-secondary));
  font-size: 0.8rem;
  line-height: 1.4;
  opacity: 0.9;
`;

export const CardActions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem 1.15rem 1rem 0;
  border-left: 1px solid color-mix(in srgb, var(--border-default) 70%, transparent);

  @media (max-width: 720px) {
    grid-column: 2;
    flex-direction: row;
    padding: 0 1.15rem 1rem;
    border-left: none;
  }
`;

export const PrimaryButton = styled.button`
  appearance: none;
  border: none;
  border-radius: 999px;
  padding: 0.6rem 1.1rem;
  background: var(--accent);
  color: var(--text-on-accent, #fff);
  font-weight: 600;
  font-size: 0.88rem;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const GhostButton = styled.button`
  appearance: none;
  border: 1px solid var(--border-default);
  border-radius: 999px;
  padding: 0.55rem 1rem;
  background: transparent;
  color: var(--text-primary);
  font-weight: 600;
  font-size: 0.88rem;
  cursor: pointer;
`;

export const EmptyState = styled.div`
  padding: 2.5rem 1.5rem;
  text-align: center;
  border-radius: 16px;
  border: 1px dashed var(--border-default);
  color: var(--text-secondary);
  background: color-mix(in srgb, var(--surface-2) 70%, transparent);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.65rem;

  svg {
    color: var(--accent);
    opacity: 0.85;
  }

  strong {
    color: var(--text-heading);
    font-size: 1.05rem;
  }

  p {
    margin: 0;
    max-width: 36ch;
    line-height: 1.45;
  }
`;

export const LoadingText = styled.p`
  color: var(--text-secondary);
  margin: 1rem 0;
`;

export const DetailCard = styled.section`
  padding: 1.35rem 1.4rem;
  border-radius: 16px;
  border: 1px solid var(--border-default);
  background: var(--surface-overlay, var(--surface-1));
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`;

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem 1.25rem;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

export const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;

  span {
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--text-muted, var(--text-secondary));
  }

  strong {
    color: var(--text-primary);
    font-size: 0.95rem;
    font-weight: 600;
    word-break: break-word;
  }
`;

export const CheckboxRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  border: 1px solid var(--border-default);
  background: color-mix(in srgb, var(--accent) 8%, transparent);
  cursor: pointer;
  color: var(--text-primary);
  font-size: 0.92rem;
  line-height: 1.45;

  input {
    margin-top: 0.2rem;
  }

  &[data-disabled="true"] {
    opacity: 0.75;
    cursor: default;
  }
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`;

export const Label = styled.label`
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--text-heading);
`;

export const Select = styled.select`
  width: 100%;
  max-width: 420px;
  padding: 0.55rem 0.7rem;
  border-radius: 10px;
  border: 1px solid var(--border-default);
  background: var(--input-bg, var(--surface-1));
  color: var(--text-primary);
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 110px;
  padding: 0.65rem 0.75rem;
  border-radius: 10px;
  border: 1px solid var(--border-default);
  background: var(--input-bg, var(--surface-1));
  color: var(--text-primary);
  resize: vertical;
  font: inherit;
`;

export const CheckList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
`;

export const CheckItem = styled.label`
  display: flex;
  align-items: center;
  gap: 0.55rem;
  color: var(--text-primary);
  font-size: 0.9rem;
`;

export const ErrorText = styled.p`
  margin: 0;
  color: var(--danger);
  font-size: 0.9rem;
`;

export const ActionsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  margin-top: 0.5rem;
`;

export const FileRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
`;

export const DescriptionBox = styled.div`
  padding: 1rem 1.1rem;
  border-radius: 12px;
  border: 1px solid var(--border-default);
  background: color-mix(in srgb, var(--surface-2) 80%, transparent);
  color: var(--text-primary);
  font-size: 0.95rem;
  line-height: 1.55;
  white-space: pre-wrap;
  max-height: 220px;
  overflow: auto;
`;

export const InfoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  border: 1px solid var(--border-default);
  background: color-mix(in srgb, var(--surface-1) 90%, transparent);
`;

export const InfoRow = styled.div`
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 0.75rem;
  align-items: center;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
    gap: 0.2rem;
  }
`;

export const InfoLabel = styled.span`
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--text-muted, var(--text-secondary));
`;

export const InfoValue = styled.span`
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary);
  word-break: break-word;
`;

export const LocationBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const CoordinatesText = styled.p`
  margin: 0;
  font-size: 0.9rem;
  color: var(--text-secondary);

  strong {
    color: var(--text-primary);
  }
`;

export const MapsLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  width: fit-content;
  padding: 0.45rem 0.9rem;
  border-radius: 999px;
  border: 1px solid var(--border-default);
  color: var(--accent);
  font-weight: 600;
  font-size: 0.88rem;
  text-decoration: none;
  background: color-mix(in srgb, var(--accent) 10%, transparent);

  &:hover {
    background: color-mix(in srgb, var(--accent) 18%, transparent);
  }
`;

export const SectionTitle = styled.h3`
  margin: 0.35rem 0 0;
  font-size: 1.05rem;
  color: var(--text-heading);
`;
